import React from 'react'
import PropTypes from 'prop-types'

import { Card, List } from 'semantic-ui-react'

import CardProperty from 'Components/CardProperty'
import Permissions from 'Components/Permissions'

import * as rugHelpers from 'Global/Helpers/rugHelpers'
import { getFormattedDateString } from 'Global/Helpers/timeHelpers'

const RugCardContent = ({ rug }) => {
  return (
    <Permissions
      permissions={['rug.field.dateOrder', 'rug.field.edges', 'rug.field.producerCode', 'rug.field.quality', 'rug.field.size']}
      render={() => (
        <Card.Content extra>
          <List>
            {rug.sizeH && rug.sizeW && (
              <Permissions
                permissions="rug.field.size"
                render={() => (
                  <CardProperty icon="expand" popUpContent="Size">
                    {`${rug.sizeW}cm x ${rug.sizeH}cm (${rug.sizeQm}qm)`}
                  </CardProperty>
                )}
              />
            )}

            {rug.knotDescription && (
              <Permissions
                permissions="rug.field.quality"
                render={() => (
                  <CardProperty icon="share alternate" popUpContent="Quality">
                    {rug.knotDescription}
                  </CardProperty>
                )}
              />
            )}

            {rug.dessin && (
              <Permissions
                permissions="rug.field.edges"
                render={() => (
                  <CardProperty icon="block layout" popUpContent="Edges">
                    {rugHelpers.getDessinName(parseInt(rug.dessin, 10))}
                  </CardProperty>
                )}
              />
            )}

            {rug.producerCode && (
              <Permissions
                permissions="rug.field.producerCode"
                render={() => (
                  <CardProperty icon="factory" popUpContent="Producer">
                    {rug.producerCode}
                  </CardProperty>
                )}
              />
            )}

            {rug.dateOrder && (
              <Permissions
                permissions="rug.field.dateOrder"
                render={() => (
                  <CardProperty icon="calendar" popUpContent="Date Order">
                    {getFormattedDateString(rug.dateOrder)}
                  </CardProperty>
                )}
              />
            )}
          </List>
        </Card.Content>
      )}
    />
  )
}

RugCardContent.propTypes = {
  rug: PropTypes.object.isRequired,
}

export default RugCardContent
